module.exports = __webpack_public_path__ + "img/nongMin4.4e806255.png";